import { Box, Typography } from "@mui/material";

const EmployeeLeaves = () => {
  return (
    <Box m="20px">
      <Typography variant="h2" fontWeight="bold">
        Employee Leaves
      </Typography>
    </Box>
  );
};

export default EmployeeLeaves;